// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCXfRpmoEwfdl7dDNwZCw0CrtO2CJsz8_k",
  authDomain: "cloud-point-landing-page.firebaseapp.com",
  projectId: "cloud-point-landing-page",
  storageBucket: "cloud-point-landing-page.appspot.com",
  messagingSenderId: "358202948327",
  appId: "1:358202948327:web:7fec1b6d78bdba86af4042",
  measurementId: "G-2N05VR8SQY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firestore
const db = getFirestore(app);

const analytics = getAnalytics(app);

export { app, db, analytics };
